import $ from 'cash-dom';
import svg4everybody from 'svg4everybody';
import {
  changeHeaderMenu,
  changeProduct,
  openMenu,
} from './components/header';
import inpageScroll from './components/inpageScroll';
import scrollMenu from './components/scrollMenu';
import carAnimate from './components/carAnimate';
import aerodynamicsAnimate from './components/aerodynamicsAnimate';
import showImages from './components/showImages';
import productPopup from './components/productPopup';
import carHeroAnimate from './components/carHeroAnimate';
import initCategories from './components/showCategories';
import initForm from './components/form';
import initHistoryItems from './components/historyItems';

svg4everybody();

$(document).ready(() => {
  changeHeaderMenu();
  changeProduct();
  openMenu();
  inpageScroll();
  scrollMenu();
  carAnimate();
  aerodynamicsAnimate();
  showImages();
  productPopup();
  carHeroAnimate();
  initCategories();
  initForm();
  initHistoryItems();
});
